<template>
  <b-modal ref="modal" hide-footer :title="product ? `Select an option — ${product.product}` : 'Select an option'" static>
    <div v-if="product">
      <div v-if="!variants.length" class="text-center text-muted py-3">
        This item has no sellable options yet.
      </div>

      <div v-else class="list-group">
        <button
          type="button"
          v-for="variant in variants"
          :key="variant.id"
          class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
          :disabled="isOut(variant)"
          @click="choose(variant)"
        >
          <span>
            <span class="font-weight-bold">{{ variant.name }}</span>
            <small v-if="variant.sku" class="d-block text-muted">{{ variant.sku }}</small>
          </span>
          <span class="text-right">
            <span class="d-block">{{ convertCurrencyToLocal(variant.ppu) }}</span>
            <small :class="isOut(variant) ? 'text-danger' : 'text-muted'">
              {{ isOut(variant) ? 'Out of stock' : `${variant.remaining_units} in stock` }}
            </small>
          </span>
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
/**
 * Lets the merchant choose which variant (e.g. Color/Size) of a
 * has_variants=true product they're selling, before it's added to the cart.
 * The chosen variant is reshaped into the same flat POS payload
 * PosService::variantToPosArray() already returns for a variant barcode
 * scan, so the caller can feed it straight into the normal addToCart(Fast)
 * pipeline unchanged. See docs/product-variations-units-implementation-plan.md
 * Part 16.
 */
export default {
  name: 'VariantPickerModal',
  data() {
    return {
      product: null,
    };
  },
  computed: {
    variants() {
      return (this.product && this.product.variants) || [];
    },
  },
  methods: {
    open(product) {
      this.product = product;
      this.$refs.modal.show();
    },
    isOut(variant) {
      return !variant.is_service && Number(variant.remaining_units) <= 0;
    },
    choose(variant) {
      if (this.isOut(variant)) return;

      const parent = this.product;
      this.$emit('selected', {
        id: variant.id,
        product_id: parent.id,
        product_variant_id: variant.id,
        product: `${parent.product} — ${variant.name}`,
        variant_name: variant.name,
        sku: variant.sku,
        ppu: variant.ppu,
        effective_price: variant.ppu,
        wholesale_sp: variant.wholesale_sp,
        wholesale_ppu: variant.wholesale_ppu,
        remaining_units: variant.remaining_units,
        is_service: parent.is_service,
        can_be_sold: variant.can_be_sold,
        is_directly_proportional: parent.is_directly_proportional,
        affects_profit: parent.affects_profit,
        affects_inventory: parent.affects_inventory,
        bg_color: variant.bg_color || parent.bg_color,
        img: parent.img,
        units: variant.units || [],
        has_variants: false,
        campaign_label: null,
      });
      this.$refs.modal.hide();
    },
  },
};
</script>
